import resolveSubjectTypeIcon from '@Guidelines/Component/SubjectTypeTile/Helpers/resolveSubjectTypeIcon';
import { css } from '@emotion/react';
import type * as React from 'react';

const rowStyle = css`
	display: inline-flex;
	align-items: center;
	gap: 0.625rem;
`;

type Props = { icon: string; label: string };

/** A 16 px subject type icon followed by its label, for the icon list and its trigger. */
const IconOption: React.FC<Props> = ({ icon, label }) => {
	const Icon = resolveSubjectTypeIcon(icon);

	return (
		<span css={rowStyle}>
			<Icon size={16} aria-hidden="true" />
			{label}
		</span>
	);
};

export default IconOption;
